import { Injectable } from "@angular/core";

import { combineLatest, Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { DffError } from "@dffedb/util";
import { InstallationMaalerAflaesningMedMaalerType, InstallationMaalerAflaesningService } from "@e-forsyning/common/maaler";

import { FlyttemeddelelseFormBuilder } from "../flyttemeddelelse/flyttemeddelelse.form-builder";
import { FlyttemeddelelseIndstillinger } from "../model/flyttemeddelelse-indstillinger.model";
import { IFlyttemeddelelse } from "../model/flyttemeddelelse.model";
import { FlyttemeddelelseViewModel } from "../model/flyttemeddelelse.view-model";
import { FlyttemeddelelseRepository } from "./flyttemeddelelse.repository";

@Injectable({ providedIn: "root" })
export class FlyttemeddelelseSandbox {
    constructor(
        private readonly flyttemeddelelseRepository: FlyttemeddelelseRepository,
        private readonly installationMaalerAflaesningService: InstallationMaalerAflaesningService
    ) {}

    public hentViewModel(): Observable<FlyttemeddelelseViewModel> {
        const indstillinger$ = this.hentIndstillinger();
        const maalerAflaesning$ = this.hentMaalerAflaesning();
        return combineLatest([indstillinger$, maalerAflaesning$]).pipe(
            map(([indstillinger, maalerAflaesning]) => {
                const formGroup = FlyttemeddelelseFormBuilder.opretForm(indstillinger, maalerAflaesning);
                return { formGroup, indstillinger };
            })
        );
    }

    public hentIndstillinger(): Observable<FlyttemeddelelseIndstillinger> {
        return this.flyttemeddelelseRepository.hentIndstillinger();
    }

    public hentMaalerAflaesning(): Observable<InstallationMaalerAflaesningMedMaalerType> {
        return this.installationMaalerAflaesningService.hentMaalerAflaesningForAktuelleInstallation();
    }

    public opretFlyttemeddelelse(flyttemeddelelse: IFlyttemeddelelse): Observable<void> {
        return this.flyttemeddelelseRepository.opretFlyttemeddelelse(flyttemeddelelse).pipe(
            map(() => null),
            catchError((e) =>
                throwError(
                    new DffError(e.message, { friendlyMessage: "Fejl i opret flyttemeddelelse.", innerError: e, showNotification: true })
                )
            )
        );
    }
}
